// extracted by mini-css-extract-plugin
module.exports = {"link":"browse-BrowselistContainer__link--1SPM4","headline":"browse-BrowselistContainer__headline--iY3Zg"};